module.exports = __webpack_public_path__ + "img/5.82b63b9a.jpg";